import { FETCH_INGREDIENT_IMAGES } from "../actions/types";

const ingredientImages = (state = {}, action) => {
  switch (action.type) {
    case FETCH_INGREDIENT_IMAGES:
      return action.payload;
    default:
      return state;
  }
};

export default ingredientImages;
